import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { SpinnerModule } from '@spartacus/storefront';

import { KnBrDraftSearchResultComponent } from './kn-br-draft-search-result.component';
import { KnBrCustomPipesModule } from 'src/app/shared/pipe/kn-br-custom-pipes/kn-br-custom-pipes.module';

@NgModule({
    imports: [
        CommonModule,
        I18nModule,
        SpinnerModule,
        NgbTooltipModule,
        KnBrCustomPipesModule,
        ConfigModule.withConfig({
            cmsComponents: {
                KnBrDraftOrderSearchResultComponent: {
                    component: KnBrDraftSearchResultComponent,
                },
            },
        } as CmsConfig),
        KnBrDraftSearchResultComponent,
    ],
})
export class KnBrDraftSearchResultModule {}
